import Lenis from "lenis";

// Pausar Lenis cuando estña el modal de Cookiebot abierto
function pauseLenis() {
  if (!window.lenis) return;

  window.lenis.stop(); // Detiene el efecto de Lenis
}

function resumeLenis() {
  if (!window.lenis) return;

  window.lenis.start(); // Reactiva Lenis después de cerrar el modal
}

// Detectar cuando el modal de Cookiebot se abre
document.addEventListener("CookiebotOnDialogDisplay", () => {
  pauseLenis();
});

// Detectar cuando el modal de Cookiebot se cierra
document.addEventListener("CookieConsentDialogClosed", () => {
  resumeLenis();
});

// Initialize Lenis
const lenis = new Lenis({
  autoRaf: true,
});

window.lenis = lenis;

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);
